import { useMemo } from 'react';
import { USER_EXPERTISE } from '@hotjar/webapp/domains/activation/user-personalization-info';

export interface ExpertiseSelection {
  label: string;
  value: USER_EXPERTISE;
}

export const useExpertiseSelection = (): ExpertiseSelection[] => {
  return useMemo(() => {
    return [
      {
        label: `activation:onboarding.organization-steps.expertise.options.${USER_EXPERTISE.BEGINNER}`,
        value: USER_EXPERTISE.BEGINNER,
      },
      {
        label: `activation:onboarding.organization-steps.expertise.options.${USER_EXPERTISE.INTERMEDIATE}`,
        value: USER_EXPERTISE.INTERMEDIATE,
      },
      {
        label: `activation:onboarding.organization-steps.expertise.options.${USER_EXPERTISE.EXPERT}`,
        value: USER_EXPERTISE.EXPERT,
      },
    ];
  }, []);
};
